import { useQuery } from "@tanstack/react-query";
import { getLatestScore } from "../api/score.js";
import type { ScoreRunSummary } from "../api/product-types.js";

export function useScore(websiteId: string | undefined) {
  return useQuery<ScoreRunSummary | null>({
    queryKey: ["score", websiteId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      return getLatestScore(websiteId);
    },
    enabled: websiteId != null,
  });
}
